define(['jquery', 'bootstrap'], function (jQuery) {
    /**
     * Accordion with icon to change on it and add it initial
     * only for tringle
     */
    jQuery(document).on('show.bs.collapse', function (e) {
        var dataIconClose = jQuery(e.target).parent().parent().attr('data-setu-icon-close');
        jQuery(e.target).prev('.card-header').find('span.jq-halflings-triangle, a.jq-halflings-triangle').removeClass().addClass(dataIconClose);
    });

    jQuery(document).on('hide.bs.collapse', function (e) {
        var dataIconOpen = jQuery(e.target).parent().parent().attr('data-setu-icon-open');
        jQuery(e.target).prev('.card-header').find('span.jq-halflings-triangle,  a.jq-halflings-triangle').removeClass().addClass(dataIconOpen);
    });
});
